// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2p2AP","col":"styles_col__Kyor_"};